<template>
  <jade-alert
    v-if="reasonsForRefusal"
    showIcon
    :variant="reasonsForRefusal.variant"
    :icon="reasonsForRefusal.icon"
    :link="reasonsForRefusal.link"
    @handleLinkClick="eventCaller"
  >
    {{ reasonsForRefusal.message }}
    <b v-if="reasonsForRefusalParams">
      {{ reasonsForRefusalParams }}
    </b>
  </jade-alert>
</template>

<script>
import { JadeAlert } from '@/components/jade'
import AlertReasonsForRefusal from './alert-reason-refusal.manager.js'
import sendEvent from '@utils/analiticaEventCaller.utils.js'

export default {
  name: 'AlertReasonRefusal',
  components: {
    JadeAlert
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    reasonsForRefusal () {
      const alertRefusedReason = new AlertReasonsForRefusal(
        this.data
      ).getAlerts()

      return Object.values(alertRefusedReason)
        .map(el => {
          return {
            ...el,
            message: this.$t(el.message),
            link: {
              ...el.link,
              text: this.$t(el.link.text)
            }
          }
        })
        .find(el => el.condition)
    },
    reasonsForRefusalParams () {
      const { params } = this.reasonsForRefusal
      if (!params) {
        return false
      }
      return params?.message ? this.$t(params?.message, params) : params
    }
  },
  methods: {
    eventCaller () {
      sendEvent({
        instanceName: 'chargesEvents',
        featureName: 'actions',
        functionName: 'detailsHelpMessageClicked'
      })
    }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "antiFraud": {
        "message":"Esta cobrança foi avaliada como suspeita e, por segurança, não foi aprovada pelo Antifraude.",
        "link":"Entenda o que é possível fazer, acessando a nossa Central de Ajuda"
      },
      "acquirer": {
        "message":"Esta cobrança foi recusada pelo banco emissor, com o erro: ",
        "link":"Entenda os códigos de recusa, acessando a nossa Central de Ajuda",
        "paramsText": "{acquirerMessage} - Código: {acquirerReturnCode}"
      },
      "gateway": {
        "message":"Esta cobrança falhou, com o erro:  ",
        "link":"Para mais informações, fale com o time de Atendimento ou acesse a nossa Central de Ajuda"
      },
      "genericFail": {
        "message":"Essa cobrança falhou, no entanto, não conseguimos identificar o erro.",
        "link":"Para mais informações, fale com o time de Atendimento ou acesse a nossa Central de Ajuda"
      }
    },
    "en-US": {
      "antiFraud": {
        "message":"This charge was assessed as suspicious and, for security reasons, was not approved by Anti-Fraud.",
        "link":"Understand what you can do by accessing our Help Center"
      },
      "acquirer": {
        "message":"This charge was declined by the issuing bank, with the error: ",
        "link":"Understand refusal codes by accessing our Help Center",
        "paramsText":"{acquirerMessage} - Code: {acquirerReturnCode}"
      },
      "gateway": {
        "message":"This charge failed, with the error: ",
        "link":"For more information, speak to the Customer Service team or visit our Help Center"
      },
      "genericFail": {
        "message":"This charge failed, however, we were unable to identify the error.",
        "link":"For more information, speak to the Customer Service team or visit our Help Center"
      }
    }
  }

</i18n>
